import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '@shared/models';
import { ApiParams, ApiRequest, ApiService } from './api.service';

@Injectable()
export class UserService extends ApiService<User> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'users/';
  }

  getProfile(): Observable<User> {
    return this.get({ url: 'profile/' });
  }

  changePassword(request: Partial<ApiRequest<ApiParams>>): Observable<any> {
    return this.patch({ ...request, url: 'change-password/' });
  }

  /**
   * Fetch filtered users
   * @param filterText text to filter users on
   * @param roles array to filter users by role
   */
  getFilteredUsers(filterText: string, roles?: string[]): Observable<User[]> {
    let rolesParam = '';
    if (!!roles) {
      rolesParam = roles.join(', ');
    }
    const request = {
      url: 'autocomplete',
      params: { name: filterText, roles: rolesParam },
    };
    return this.get(request);
  }

  getList(usersIds: number[]): Observable<User[]> {
    return this.post({ url: 'ids', body: usersIds });
  }
}
